// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__22FYx","location":"Header_location__3h3ex"};